import {
  HorizontalBar
} from "vue-chartjs";

export default {
  name: "GeneralHorizontalBar",
  extends: HorizontalBar,
  props: ["data", "propOptions"],
  data: () => ({
    chartdata: {
      datasets: [{
        label: ''
      }]
    },
    options: {},
  }),

  watch: {
    data(val) {
      val && this.buildChart();
    },
  },

  mounted() {
    this.buildChart();
  },

  methods: {
    async buildChart() {
      this.chartData = { ...this.chartData, ...this.data };
      this.options = { ...this.options, ...this.propOptions };
      this.renderChart(this.chartData, this.options);
    }
  }

};